// dmarc-frontend/src/components/ReportePdf.jsx
import React, { useState } from "react";
import ErrorModal from "./ErrorModal";
import { getToken } from "../../utils/auth";

export default function ReportePdf({ dominio, desde, hasta, apiRoot }) {
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    message: "",
  });

  async function handleDescargar() {
    if (!dominio) {
      setErrorModal({
        isOpen: true,
        message: "Debe ingresar un dominio para generar el reporte PDF.",
      });
      return;
    }

    setLoading(true);
    
    try {
      const urlParams = new URLSearchParams({ dominio, desde, hasta });
      const token = getToken();
      const headers = {
        Authorization: `Bearer ${token}`,
      };

       console.log("HEADERS PDF =", headers);

      if (!token) {
        throw new Error("Tu sesión no es válida o expiró. Vuelve a iniciar sesión.");
      }

      const response = await fetch(
        `${apiRoot || ""}/reports/dmarc.pdf?${urlParams.toString()}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        let msg = "El servidor de reportes no respondió correctamente.";
        try {
          const err = await response.json();
          msg = err?.detail || msg;
        } catch {
          // ignorar si no viene json
        }
        throw new Error(msg);
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `DMARC_${dominio}_${desde}_${hasta}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setErrorModal({
        isOpen: true,
        message:
          e.message ||
          "Ocurrió un error inesperado al intentar exportar el reporte a PDF.",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="flex flex-col items-start gap-1">
        <button
          onClick={handleDescargar}
          disabled={loading}
          className="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 h-[42px] border border-gray-200 dark:border-slate-700 transition flex items-center gap-2 font-bold text-sm whitespace-nowrap"
          title="Descargar PDF"
        >
          {loading ? (
            <i className="fas fa-circle-notch animate-spin"></i>
          ) : (
            <i className="fas fa-file-pdf text-red-500"></i>
          )}
          <span>PDF</span>
        </button>
      </div>

      <ErrorModal
        isOpen={errorModal.isOpen}
        title="Error de Exportación"
        message={errorModal.message}
        onClose={() => setErrorModal({ ...errorModal, isOpen: false })}
      />
    </>
  );
}
